import Vue from 'vue';
import { getProductArchiveComponent } from './productArchive.vue.js';

export function initProductArchives(archives) {
    for (const archive of archives) {
        const idBase = archive.dataset.vueProductArchive;

        new Vue({
            el: archive,
            components: { ProductArchive: getProductArchiveComponent(idBase) },
            template: `#${idBase}`,
        });
    }
}
